import { Avatar, Chip, ListItem, Button } from "@mui/material";
import { Box } from "@mui/system";
import PageRoutes from "../Config/PageRoutes";
import { Link, useParams } from "react-router-dom";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { useRef, useState, useEffect } from "react";


import CarrotIcon from "../Assets/aubergines.svg";
import CauliflowerIcon from "../Assets/bananas.svg";
import KiwiIcon from "../Assets/broccoli.svg";
import OnionIcon from "../Assets/cultivated_fungi.svg";
import OrangeIcon from "../Assets/grapefruits.svg";
import PearIcon from "../Assets/melons.svg";
import PotatoIcon from "../Assets/sweet_bell_peppers.svg";
import DriedBeansIcon from "../Assets/table_grapes.svg";
import RiceIcon from "../Assets/virgin_olive_oil.svg";
import RyeIcon from "../Assets/wheat.svg";
import BovineIcon from "../Assets/bovine_fat.svg";
import PoultryIcon from "../Assets/chicken_eggs.svg";

const CommoditiesMenu = () => {
  const commodities = [
    { name: "Aubergines", icon: CarrotIcon, activeIcon: CarrotIcon },
    { name: "Bananas", icon: CauliflowerIcon, activeIcon: CauliflowerIcon },
    { name: "Broccoli", icon: KiwiIcon, activeIcon: KiwiIcon },
    { name: "Cultivated fungi", icon: OnionIcon, activeIcon: OnionIcon },
    { name: "Grapefruits", icon: OrangeIcon, activeIcon: OrangeIcon },
    { name: "Melons", icon: PearIcon, activeIcon: PearIcon },
    { name: "Sweet/bell peppers", icon: PotatoIcon, activeIcon: PotatoIcon },
    { name: "Table grapes", icon: DriedBeansIcon, activeIcon: DriedBeansIcon },
    { name: "Virgin olive oil", icon: RiceIcon, activeIcon: RiceIcon },
    { name: "Wheat", icon: RyeIcon, activeIcon: RyeIcon },
    { name: "Bovine fat", icon: BovineIcon, activeIcon: BovineIcon },
    { name: "Chicken eggs", icon: PoultryIcon, activeIcon: PoultryIcon },    
  ];

  const { id } = useParams();
  const [active, setActive] = useState(false);

  const showCommoditiesMenu = () => {
    setActive(!active);
  };

  const container = useRef(null);

  function OutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setActive(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  OutsideClick(container);

  return (
    <Box ref={container} className="commodities-wrapper">
      <div className={active ? "commoditiesMenuWrapper active" : "commoditiesMenuWrapper"}>
        <div className="commoditiesBar">
          <div className="commoditiesBar_inner">
            <div className="arrowIcon">
              <Button sx={{ padding: "0px", zIndex: 1000 }} onClick={showCommoditiesMenu}>
                <ExpandCircleDownOutlinedIcon
                  style={{
                    color: "#fff",
                    rotate: "90deg",
                    zIndex: "1000",
                    cursor: "pointer",
                  }}
                  className={active ? "arrowSvg active" : "arrowSvg"}
                />
              </Button>
            </div>
            <div className="commoditiesBarTitle">
              <span> SELECT A FOOD COMMODITY <br /> TO VIEW DETAILED RESULTS</span>
            </div>
          </div>
        </div>
        <div className="commoditiesMenuInner">
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" },
            }}
            className={active ? "commoditiesMenu active" : "commoditiesMenu"}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "repeat(1, 1fr)", sm: "repeat(1, 1fr)", md: "repeat(3, 1fr)" },
                margin: "10px",
              }}
            >
              {commodities.map((c) => {
                const normalized = c.name.replace(" ", "_").replace("/", "-").toLowerCase();
                return (
                  <ListItem
                    className="listItem"
                    sx={{ width: "auto", display: "inline-block" }}
                    key={normalized}
                    style={{ margin: "0" }}
                  >
                    <Link to={PageRoutes.COMMODITY_ROOT + normalized} onClick={showCommoditiesMenu}>
                      <Chip
                        avatar={
                          <Avatar
                            sx={{ background: "none !important" }}
                            alt={normalized}
                            src={id && id === normalized ? c.activeIcon : c.icon}
                          />
                        }
                        clickable
                        style={{
                          padding: "2px 16px",
                          margin: "0",
                          color: id && id === normalized ? "white" : "white",
                          borderColor: "#1F5C90",
                          backgroundColor: id && id === normalized ? "#1F5C90" : "transparent",
                        }}
                        variant={id && id === normalized ? "filled" : "outlined"}
                        label={c.name}
                      />
                    </Link>
                  </ListItem>
                );
              })}
            </Box>
          </Box>
        </div>
      </div>
    </Box>
  );
};

export default CommoditiesMenu;
